module.exports = __webpack_public_path__ + "static/anli2.a30a1d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anli2.jpg
// module id = 715
// module chunks = 168707334958949